import React from "react"; 





// export const checkSelectBtnCSS = checkVal =>{
//   if(checkVal){

//   } else {
//     eventDetailsCss
//   }
// }





export const eventDetailsCss = (checkVal, mod_height, style) => {
  let height= mod_height?mod_height:'32px'
  return{
    control: (provided, state) =>({
      ...provided,
      background:  checkVal?'#e7f3ff' :'#e4e6eb',
      borderColor: 'transparent',
      minHeight: height,
      height: height,
      boxShadow: state.isFocused ? null : null,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: height,
      padding: '0 6px'
    }),
    menu: (provided, state) => ({
      ...provided,
      width: '96%',
      backgroundColor:'white',
      textAlign: 'left !important',
      marginBottom:'3px !important',
      justifyContent:'left !important'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: height,
      color: state.selectProps.data_arr.value!=0 &&checkVal?'#1877f2' :'#050505',
    }), 
    singleValue: (provided, state) => ({
      ...provided,
      color:  state.selectProps.data_arr.value!=0 &&checkVal?'#1877f2' :'#050505',
      marginLeft: state.selectProps.data_arr.value!=0 &&checkVal?'0px':'8px',
      marginRight: state.selectProps.data_arr.value!=0 &&checkVal?'0px':'2px',
      width:'100%',
      textAlign:'center'
    }),
    menuList:(provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
      // return { ...provided, opacity, transition };
    },
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.selectProps.data_arr.value!=0 &&checkVal?'#1877f2' :'#050505',
      "&:hover": {
        border: "0 !important",
        color:'inherit'
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "0.788rem",
      left: "10%",
      color: "#050505",
      fontWeight: "800",
      width:'calc(85%)`',
      overflow:'hidden',
      whiteSpace:'pre',
      textOverflow:'ellipsis'
    })
  }
}



export const customOptions = ({ children, ...props }) => {
  return (
    <option >
      <img src={props.icon} />
      {props.label}
    </option>
  );
};


export const customSingleValue = ({ data }) => (
  <div className="input-select">
      <div className="input-select__single-value">
          { data.icon && <span className="input-select__icon"><img src={ data.icon }/></span> }
          <span>{ data.label }</span>
      </div>
  </div>
);
  
  // export {customOptions, customSingleValue, eventDetailsCss};